import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import styles from "./file_details_info.module.css";
import getStringsBasedLang from "../../strings/get_strings";
import moment from "moment-jalaali";
import Axios from "axios";
import fileDownload from "js-file-download";
import CustomGauge from "../../modules/custom_gauge/custom_gauge";
import UseErrorHandling from "../../hook/UseErrorHandling";
import { createData } from "../../api/http-service";
import {url} from "../../api/http-service"
export default function FileDetailsInfo(props) {
  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("lang");
  const handleErrorApi = UseErrorHandling();

  const downloadHandler = (icon) => {
    switch (icon) {
      case "cloud_app_download":
        return downloadPDFHandler();
      case "cloud_free_download":
        return downloadHTMLHandler();
      default:
        break;
    }
  };

  const buttonHandler = (title, color, text_color, icon) => {
    return (
      <div className={styles.btn_container}>
        <button
          style={{ backgroundColor: color }}
          className={styles.btn_style}
          onClick={() => downloadHandler(icon)}
        >
          <img src={require(`../../assets/icons/${icon}.svg`)} alt="Icon" />
          <div className={`${styles.text_container} font-bold`}>
            <span className={styles.btn_text} style={{ color: text_color }}>
              {title}
            </span>
          </div>
        </button>
      </div>
    );
  };

  const infoFormatter = (title, subTitle, title_className, sub_className) => {
    return (
      <div
        className={`${styles.info_container} ${
          lang === "en" ? "!text-left" : ""
        }`}
      >
        <div
          className={`secondry_color font-bold ${title_className} ${
            lang === "en" ? "englishIranSans" : ""
          }`}
        >
          {title}
        </div>
        <div
          style={
            title === getStringsBasedLang("fileDetail_packagename")
              ? { cursor: "pointer", textDecoration: "underline" }
              : null
          }
          className={`primary_color ${sub_className} ${
            lang === "en" ? "englishIranSans" : ""
          }`}
        >
          {subTitle}
        </div>
      </div>
    );
  };

  //download HTML
  const downloadHTMLHandler = () => {
    createData(`scan/result/export/html/${props.guid}`, {
      token: token,
      lang: lang,
    })
      .then((logoutResult) => {
        const url = window.URL.createObjectURL(new Blob([logoutResult]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ScanReport.html");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        if (error?.response) {
          handleErrorApi(error?.response.data);
        }
      });
  };

  //download PDF
  const downloadPDFHandler = () => {
    Axios({
      url: `${url}/scan/result/export/pdf/${props.guid}`,
      method: "post",
      responseType: "blob",
      data: JSON.stringify({ token: token, lang: lang }),
    }).then((res) => {
      fileDownload(res.data, "ScanReport.pdf");
    });
  };

  const timeHandler = (time) => {
    if (lang === "fa")
      return moment.unix(time).format("HH:mm jYYYY-jMM-jDD").split(" ");
    else return moment.unix(time).format("HH:mm YYYY-MM-DD").split(" ");
  };
  return (
    <div className="relative">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <div className={styles.info_formatter_container}>
            <div className={styles.package_container}>
              {/* {infoFormatter(strings.general_fileCount, props.data !== undefined && props.data.files_count, null, `${styles.subTitle_style} englishIranSans`)} */}
              {infoFormatter(
                getStringsBasedLang("fileDetail_antiCount"),
                props.data !== undefined &&
                  Object.values(props.data.avs).length,
                null,
                `${styles.subTitle_style} englishIranSans`
              )}
              {infoFormatter(
                getStringsBasedLang("general_md5"),
                props.data !== undefined && props.data.md5,
                "englishIranSans",
                `${styles.subTitle_style} englishIranSans`
              )}
            </div>
            <div className={`${styles.sha_container}`}>
              {infoFormatter(
                "SHA-1",
                props.data !== undefined && props.data.sha1,
                "englishIranSans",
                "englishIranSans"
              )}
            </div>
            <div className={`${styles.sha_container}`}>
              {infoFormatter(
                getStringsBasedLang("general_sha256"),
                props.data !== undefined && props.data.sha256,
                "englishIranSans",
                "englishIranSans"
              )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={5}>
          <div className={styles.info_formatter_container}>
            <div className={styles.time_container}>
              {infoFormatter(
                getStringsBasedLang("general_lastDateReviewed"),
                timeHandler(props.data.updated_at)[1].replace(/-/g, "/")
              )}
              <div
                className={`${
                  lang === "en" ? "ml-[40px]" : "mr-[40px]"
                } text-center`}
              >
                {infoFormatter(
                  getStringsBasedLang("general_lastTimeReviewed"),
                  timeHandler(props.data.updated_at)[0]
                )}
              </div>
            </div>
          </div>
        </Grid>
        <div className={styles.sha_container_mobile}>
          {infoFormatter(
            "SHA-1",
            props.data !== undefined && props.data.sha1,
            "englishIranSans",
            `${styles.subTitle_style} englishIranSans`
          )}
          {infoFormatter(
            getStringsBasedLang("general_sha256"),
            props.data !== undefined && props.data.sha256,
            "englishIranSans",
            `${styles.subTitle_style} englishIranSans`
          )}
        </div>
        <Grid item xs={12} sm={12} md={4} lg={3}>
          <div
            className={`${styles.downloads_container} ${
              styles.info_formatter_container
            } ${lang === "en" ? "" : "text-right"}`}
          >
            {buttonHandler(
              getStringsBasedLang("general_htmlDownload"),
              "#f1f3f9",
              "#07465d",
              "cloud_free_download"
            )}
            <div className={styles.downloadd_app_container}>
              {buttonHandler(
                getStringsBasedLang("general_PDFDownload"),
                "#e3f5f1",
                "#41b9a2",
                "cloud_app_download"
              )}
            </div>
            <div className="flex flex-col sm:mb-5 xs:mb-5 w-[160px] xs:ml-3 sm:ml-3 md:ml-2">
              <span className="secondry_color font-bold text-center">
                {getStringsBasedLang("riskLevel")}
              </span>
              <div className="">
                <CustomGauge data={props.data} />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
